// extracted by mini-css-extract-plugin
export default {"header":"DashboardHeader_header__pk1yQ","title":"DashboardHeader_title__Ww2to"};